import { render } from "./NewsCard.vue?vue&type=template&id=60f4fd14"
import script from "./NewsCard.vue?vue&type=script&lang=js"
export * from "./NewsCard.vue?vue&type=script&lang=js"

import "./NewsCard.vue?vue&type=style&index=0&id=60f4fd14&lang=css"
script.render = render

export default script